export interface IFetchBrowser {
  code: number;
  message: string;
  result: {
    queryTime: string;
    browserList: Array<{
      headImg: string;
      name: string;
    }>;
  };
}

export interface IGetPushMessage {
  code: number;
  message: string;
  result: {
    browserPayerList: Array<{
      nikeName: string;
      headImg: string;
      showTime: string;
      type: string;
    }>;
    commentList: Array<{
      headImg: string;
      nikeName: string;
      showTime: string;
      content: string;
    }>;
    historyBuyerList: Array<{
      headImg: string;
      projectName: string;
      nikeName: string;
      buyerNum: number | string;
    }>;
  };
}

export interface IFetchOrdersNum {
  code: number;
  message: string;
  result: {
    browserNum: number;
    orderSaleNum: number;
    ordersNum: number;
    stock: number;
  };
}

export interface IFetchGoodsPurchaseNum {
  code: number;
  message: string;
  result: Array<{
    goodsId: number;
    purchaseNum: number;
    convenienceGoods: boolean;
  }>;
}

export interface IFetchGoodsPurchaseInfo {
  code: number;
  message: string;
  result: {
    id: number;
    name: string;
    bannerImg: string;
    desc: string;
    goodsList: IFetchGoodsList[];
    introduceList: IFetchGoodsIntroduceList[];
  };
}
export interface IFetchGoodsList {
  activity: {
    limit_buy_num?: number;
  };
  comment?: {
    score: number;
    totalNum: number;
  };
  goodsId: number;
  goodsName: string;
  groupOn: boolean;
  goodsImg: string;
  minPrice: number;
  goodsLimitNum: number | null | undefined;
  sunshineCommunity: boolean;
  sunshinePrice: number;
  snapId: number;
  supplierId: number;
  categoryId: number;
  bounty: number;
  userOrderedNum: number | null | undefined;
  specs: IFetchGoodsSpecs[];
  products: IFetchGoodsProducts[];
  vaild: boolean;
  sellOut: boolean;
  package: boolean;
  cartNum: number;
  goodslable: Array<string>;
  purchaseNum: number;
}

export interface IFetchGoodsSpecs {
  spec_id: number;
  name: string;
  entrys: Array<{
    entry_id: string;
    value: string;
  }>;
}

export interface IFetchGoodsProducts {
  product_id: number;
  price: number;
  stock: number;
  property: [];
}

export interface IFetchGoodsIntroduceList {
  goodsName: string;
  imgList: [];
}

export interface IFetchPurchasesList {
  code: number;
  message: string;
  result: {
    current: number;
    list: IFetchOrderList[];
    orderId: number;
    total: number;
  };
}

export interface IFetchOrderList {
  headImg: string;
  name: string;
  projectName: string;
  goodsName: string;
  num: number;
  orderId: number;
  rank: number;
}

export const BUSINESS_TYPE = {
  SUPPLIER: 'market:supplier.index',
  PRODUCT: 'market:goods.index',
  ACTIVITY: 'market:theme.index',
  CART: 'market:cart.index',
  ATMOSPHERE: 'market:atmosphere.index',
  WANRENTUAN: 'market:custom.activity.index',
};
export type BussinessType = keyof typeof BUSINESS_TYPE;
export enum CouponStatus {
  canGet, // 可领取， 未领取
  over, // 不可领取， 已抢光
  get, // 已领取
}

export enum Achieved {
  no, //  抢光，不可获取
  yes, // 可获取
}

export enum Received {
  no, //  已领取
  yes, // 可领取
}
export interface IFetchCouponList {
  code: number;
  message: string;
  result: Array<{
    discount_condition: string;
    remark: string; // "备注说明",
    object: string; //   商户专享 平台券
    is_achieved: number; // 0 抢光，不可获取 1 可获取
    source: number;
    route: string; // 跳转URL
    title: string;
    is_received: number; // 0 已领取 1 可领取
    discount: string;
    end_time: number;
    release_batch: string;
    type: number; // 0 优惠券 专用券  1 代金券 金额（100） 2 折扣券 折扣（4.5折） 3 提货券 提货券
    start_time: number;
    condition: string;
    qr_code: string;
    rule: string;
    status: 1 | 2 | 3; // 1 未使用 2 已使用 3 已过期,
  }>;
}
export interface IFetchAchieveCoupon {
  code: number;
  message: string;
  result: {
    release_batch: string;
    is_achieved: number;
    is_received: number;
  };
}
export interface IFetchShare {
  code: number;
  message: string;
  result: Array<{
    img: string;
    path: string;
    title: string;
  }>;
}
